import { FormControl, UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { AllocationTruckInformationInputModel } from './allocation-truck.model';
import { AllocationUliDetails } from './allocation-uli-details.model';

export class AllocationDetailsModel {
  hubId: number = null;
  truckInformation?: AllocationTruckInformationInputModel | Record<string, never> = null;
  uliDetails?: AllocationUliDetails[] = [];

  constructor(params?: AllocationDetailsModel) {
    if (params?.hubId && params?.truckInformation && params?.uliDetails) {
      Object.assign(this, params);
    }

    if (params?.hubId && !params?.truckInformation && !params?.uliDetails) {
      this.hubId = params.hubId;
      this.truckInformation = {};
    }

    this.uliDetails = (params?.uliDetails ?? []).flat() as AllocationUliDetails[];
  }
}

export class AllocateActionRequestModel {
  compartmentId: number;
  details: AllocationDetailsModel;

  constructor(params?: AllocationDetailsModel, compartmentId?: number) {
    if (params) {
      this.compartmentId = compartmentId;
      this.details = new AllocationDetailsModel(params);
    }
  }
}

export class AllocationDetailsForm {
  constructor(
    model: AllocationDetailsModel,
    fb: UntypedFormBuilder,
    public hubId: FormControl<number> = new FormControl(model.hubId),
    public truckInformation: FormControl<
      AllocationTruckInformationInputModel | Record<string, never>
    > = new FormControl(model.truckInformation),
    public uliDetails: UntypedFormArray = fb.array([], [Validators.required]),
  ) {}
}
